var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amenity-detail',{attrs:{"bookings":_vm.bookings,"is-loading":_vm.isLoading,"amenity":_vm.amenity,"get-type-image":_vm.getTypeImage}})}
var staticRenderFns = []

export { render, staticRenderFns }